import { render, staticRenderFns } from "./forgetpass.vue?vue&type=template&id=1faa7950&scoped=true&"
import script from "./forgetpass.vue?vue&type=script&lang=js&"
export * from "./forgetpass.vue?vue&type=script&lang=js&"
import style0 from "./forgetpass.vue?vue&type=style&index=0&id=1faa7950&lang=less&scoped=true&"
import style1 from "./forgetpass.vue?vue&type=style&index=1&id=1faa7950&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faa7950",
  null
  
)

export default component.exports